import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { MatIconModule } from '@angular/material/icon';

export interface SnackbarData {
  message: string;
  type: 'success' | 'error' | 'warning' | 'info';
}

@Component({
  selector: 'app-custom-snackbar',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  encapsulation: ViewEncapsulation.None,
  template: `
    <div class="custom-snackbar-content">
      <div class="snackbar-icon" [ngClass]="'icon-' + data.type">
        <mat-icon>{{ getIcon() }}</mat-icon>
      </div>
      <span class="snackbar-text">{{ data.message }}</span>
    </div>
  `,
  styles: [`
    .custom-snackbar-content {
      display: flex;
      align-items: center;
      gap: 12px;
      width: 100%;
    }

    .snackbar-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 28px;
      height: 28px;
      border-radius: 50%;
      flex-shrink: 0;
      position: relative; /* Ensure consistent positioning */
    }

    .snackbar-icon mat-icon {
      font-size: 18px !important;
      width: 18px !important;
      height: 18px !important;
      line-height: 18px !important;
      font-weight: 600 !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
    }

    /* Success - Green */
    .snackbar-icon.icon-success {
      background-color: #d4edda;
      color: #155724;
    }

    /* Error - Red */
    .snackbar-icon.icon-error {
      background-color: #f8d7da;
      color: #721c24;
    }

    /* Warning - Orange/Yellow */
    .snackbar-icon.icon-warning {
      background-color: #fff3cd;
      color: #856404;
    }

    /* Info - Blue */
    .snackbar-icon.icon-info {
      background-color: #d1ecf1;
      color: #0c5460;
    }

    .snackbar-text {
      flex: 1;
      font-size: 14px;
      font-weight: 500;
      color: #212529;
      line-height: 1.5;
      letter-spacing: 0.01em;
    }
  `]
})
export class CustomSnackbarComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: SnackbarData,
    private snackBarRef: MatSnackBarRef<CustomSnackbarComponent>
  ) {}

  getIcon(): string {
    switch (this.data.type) {
      case 'success':
        return 'check_circle';
      case 'error':
        return 'error'; // Changed from 'cancel' to 'error'
      case 'warning':
        return 'warning';
      case 'info':
        return 'info';
      default:
        return 'info';
    }
  }
}
